module.exports = __webpack_public_path__ + "img/945_business_employee_woman_resume_recruitment_success_selected-256.5d6824f7.png";